export const PERSON_PROMOCODE = "PERSON_PROMOCODE";
export const PERSON_PROMOCODE_SUCCESS = "PERSON_PROMOCODE_SUCCESS";
export const PERSON_PROMOCODE_ERROR = "PERSON_PROMOCODE_ERROR";